import { Icon, IconProps } from '@chakra-ui/react';
import 'components/icons/contact.scss';

/**
 * @deprecated Move to storybook instead
 */
export const ContactIcon = (props: IconProps) => {
  return (
    <Icon
      className="merc-icon-contact"
      width="10"
      height="11"
      viewBox="0 0 10 11"
      fill="none"
      {...props}
    >
      <path
        d="M9 10V9C9 8.46957 8.78929 7.96086 8.41421 7.58579C8.03914 7.21071 7.53043 7 7 7H3C2.46957 7 1.96086 7.21071 1.58579 7.58579C1.21071 7.96086 1 8.46957 1 9V10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 5C6.10457 5 7 4.10457 7 3C7 1.89543 6.10457 1 5 1C3.89543 1 3 1.89543 3 3C3 4.10457 3.89543 5 5 5Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};
